module.exports = __webpack_public_path__ + "static/media/2.9bce3b17.webp";